<ng-container *ngIf="pickerValue">
  <!-- Date -->
  <mat-form-field *ngIf="mode === 'date'" appearance="outline">
    <mat-label>{{ displayTitle }}</mat-label>
    <input matInput [matDatepicker]="dp" [placeholder]="displayTitle" [formControl]="pickerValue" [min]="minDate" (blur)="onDateBlur($event)" />
    <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
    <mat-datepicker #dp></mat-datepicker>
  </mat-form-field>

  <!-- Hour -->
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" *ngIf="mode === 'time'">
    <span class="ebo-time-picker-label">{{ displayTitle }}</span>
    <input
      [ngxMatTimepicker]="pickerTime"
      [format]="24"
      [formControl]="pickerValue"
      [disableClick]="true"
      readonly
      [placeholder]="displayTitle"
    />
    <ngx-mat-timepicker timepickerClass="ebo-clock" color="accent" #pickerTime></ngx-mat-timepicker>
    <mat-icon style="cursor: pointer" (click)="pickerTime.open()">schedule</mat-icon>
  </div>

  <!-- Date + Hour -->
  <mat-form-field *ngIf="mode === 'datetime'" appearance="outline">
    <mat-label>{{ displayTitle }}</mat-label>
    <input
      matInput
      [ngxMatDatetimePicker]="dtp"
      [placeholder]="displayTitle"
      [formControl]="pickerValue"
      (input)="onManualDateTimeInput($event)"
    />
    <ngx-mat-datetime-picker #dtp [eboOpenAtNow]="pickerValue">
      <ngx-mat-datepicker-actions>
        <button mat-stroked-button ngxMatDatepickerApply><mat-icon>check</mat-icon></button>
      </ngx-mat-datepicker-actions>
    </ngx-mat-datetime-picker>
    <mat-datepicker-toggle matSuffix [for]="dtp"></mat-datepicker-toggle>
  </mat-form-field>
</ng-container>
